// PatchCollection is not publicly exported from RTK — inline the shape we need.
type PatchCollection = { undo: () => void }

// Runs an optimistic cache patch: awaits the mutation, rolls back the patch on
// failure. Call after `dispatch(api.util.updateQueryData(...))` inside
// `onQueryStarted` to dedupe the try/await/undo boilerplate.
export const runOptimistic = async (
  queryFulfilled: Promise<unknown>,
  patch: PatchCollection,
): Promise<void> => {
  try {
    await queryFulfilled
  } catch {
    patch.undo()
  }
}
